/**
 * требуется реактивное свойство (props или data)
 * sortFields: [],
 * данные столбцов таблицы должны быть в поле table.columns в data
 */

export default {
  mounted() {
    if (!this.sortFields.length) {
      const unwatchOrders = this.$watch('sortFields', () => {
        if (this.sortFields) {
          this.setSortColumns()
          unwatchOrders()
        }
      })
    } else {
      this.setSortColumns()
    }
  },
  methods: {
    setSortColumns() {
      const sortFields = this.sortFields.map(sortField => {
        return sortField.split('__').join('.')
      })
      sortFields.forEach(sortField => {
        const column = this.table.columns.find(column => column.field === sortField)
        if (column) {
          column.sortable = true
        }
      })
    },
  }
}